import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isValidCnpj } from './cnpj';
import { detectDocumentType, isValidCpfCnpj, stripDocumentMask } from './document';
import { isValidCpf } from './cpf';
import { CNPJ_LENGTH, CPF_LENGTH } from './constants';

export const cnpjValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value;

  if (!value) {
    return null;
  }

  return isValidCnpj(value) ? null : { invalidCnpj: { value } };
};

export const cpfCnpjValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value;

  if (!value) {
    return null;
  }

  const stripped = stripDocumentMask(value);
  const documentType = detectDocumentType(value);

  if (documentType === 'cpf') {
    if (stripped.length !== CPF_LENGTH) {
      return { invalidCPF: { value } };
    }

    return isValidCpf(value) ? null : { invalidCPF: { value } };
  }

  if (documentType === 'cnpj') {
    if (stripped.length !== CNPJ_LENGTH) {
      return { invalidCNPJ: { value } };
    }

    return isValidCnpj(value) ? null : { invalidCNPJ: { value } };
  }

  return { invalidCPF: { value } };
};

export const isValidCpfCnpjDocument = isValidCpfCnpj;
